import { createApp } from 'vue'
import Notification from './tw-notification.vue'
import { setNotifyFunction } from './notification'

export default {
  install (app) {
    // Create a container for the notification component
    const container = document.createElement('div');
    document.body.appendChild(container)

    // Create an app instance for the notification component
    const notificationApp = createApp(Notification)
    const instance = notificationApp.mount(container)

    // Method to show the notification
    const showNotification = (message, type = 'success', duration = 5) => {
      instance.show(message, type, duration)
    }

    // Register the showNotification method globally
    app.config.globalProperties.$notify = showNotification
    // Set the notify function reference in the notification module
    setNotifyFunction(showNotification)
  }
}
